import { render, staticRenderFns } from "./CustomerInput.vue?vue&type=template&id=1cefd4b6&scoped=true&"
import script from "./CustomerInput.vue?vue&type=script&lang=js&"
export * from "./CustomerInput.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInput.vue?vue&type=style&index=0&id=1cefd4b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cefd4b6",
  null
  
)

/* custom blocks */
import block0 from "./CustomerInput.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports